<div class="page-layout blank fullwidth p-12" fusePerfectScrollbar>
    <!-- <mat-progress-bar class="mt-8" *ngIf="loading" mode="indeterminate"></mat-progress-bar> -->
    <div class="mat-elevation-z8 mt-8 p-8 variant">  
       
        <!-- Tabs -->
        <div class="row vehicle-detail-header">
            <button style="z-index: 11;background: none;border: none;cursor: pointer;width: 5%; margin-left: 12px;"  class="font-2x fw-600 pull-left text-red" (click)="goToYear()">
                <svg xmlns="http://www.w3.org/2000/svg" class=" filter-red  font-2x fw-600 pull-left  back-button">
                    <path  d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z" />
                </svg>
            </button>
            <div class="vehicle-detail-label justify-content-center d-flex fw-600 text-center" style="cursor: pointer;" (click)="goToMake()">
                <div class="t-b ff-p" style="width: fit-content; overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;">{{selectedMake}}
                    <hr class="non_active_hr">
                </div>
            </div>
            <div class="vehicle-detail-label justify-content-center d-flex text-center" style="cursor: pointer;" (click)="goToModel()">
                <div class="ff-p" style="width: fit-content; overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;"> {{selectedModel}}
                    <hr class="non_active_hr">
                </div>
            </div>
            <div class="vehicle-detail-label justify-content-center d-flex text-center" style="cursor: pointer;" (click)="goToYear()">
                <div lass="ff-p" style="width: fit-content;">{{selectedYear}}
                    <hr class="non_active_hr">
                </div>
            </div>
            <div class="vehicle-detail-label justify-content-center d-flex text-center variant_active">
                <div lass="ff-p" style="width: fit-content;">Variant
                    <hr class="active_hr">
                </div>
            </div>
        </div>
        <!-- End Tabs -->

        <h2 class="variant-title">What's your car's variant?</h2>

        <form class="searchVariant-form">
            <input type="text" class ="search-bar" placeholder="Search for variant" [(ngModel)]='searchText' name="searchText" autocomplete="off" (keyup)="searchFilterType()">
            <mat-icon *ngIf="openSearch" style="float: right; margin-top: 10px; z-index: 9999999; position: absolute; margin-left: -35px;">search</mat-icon>
            <mat-icon *ngIf="clearSearch" style="float: right; margin-top: 10px; z-index: 9999999; position: absolute; margin-left: -35px; cursor: pointer;" (click)="clearSearchFilter()">close</mat-icon>
        </form>       


        <div class="variant-list-sec text-left">
            <mat-tab-group mat-align-tabs="center">
                <mat-tab label="Petrol" *ngIf="(variantListPetrol.length>0);">
                    <div class="variant-sec"  *ngFor="let variant of variantListPetrol|filter:searchText">
                        <button mat-raised-button class="variant_name" (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">{{variant.title}}</button>   
                    </div>
                </mat-tab>
                <mat-tab label="Diesel" *ngIf="(variantListDiesel.length>0);">
                    <div class="variant-sec"  *ngFor="let variant of variantListDiesel|filter:searchText">
                        <button mat-raised-button class="variant_name" (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">{{variant.title}}</button>   
                    </div>
                </mat-tab>
                <mat-tab label="CNG" *ngIf="(variantListCNG.length>0);">
                    <div class="variant-sec"  *ngFor="let variant of variantListCNG|filter:searchText">
                        <button mat-raised-button class="variant_name" (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">{{variant.title}}</button>   
                    </div>
                </mat-tab>
                <mat-tab label="Electric" *ngIf="(variantListElectric.length>0);">
                    <div class="variant-sec" *ngFor="let variant of variantListElectric | filter:searchText">
                        <button mat-raised-button class="variant_name"  (click)="selectVariant(variant.variantKey, variant.title, variant.fuelType)">   {{variant.title}}   </button>   
                    </div>
                </mat-tab>
              </mat-tab-group>
        </div>

    </div>
</div>
<div *ngIf="loading">
    <div #dynamicContainers></div>
    </div>